import { Link, Stack } from "expo-router";
import { Image, StyleSheet, View } from "react-native";
import { Button } from "~/components/Button";
import { Page } from "~/components/layout/Page";
import { BaseText } from "~/components/layout/text";
import { Gap, Items } from "~/constants/layout";

export default function Start() {
    return (
        <>
            <Stack.Screen options={{ headerShown: false }} />
            <Page gradient>
                <View style={styles.container}>
                    <View style={[Items.center, Gap.xl]}>
                        <Image source={require("~/assets/title-logo.png")} style={styles.logo} alt="QENDO" />
                        <View style={Items.center}>
                            <BaseText size="lg" align="center">
                                Record and track,
                            </BaseText>
                            <BaseText size="lg" align="center">
                                we’ve got your back.
                            </BaseText>
                        </View>
                    </View>
                    <View style={Gap.md}>
                        <Link href="/sign-up" asChild>
                            <Button variant="primary" size="lg" title="Get Started" />
                        </Link>
                        <Link href="/log-in" asChild>
                            <Button variant="secondary" size="lg" title="I already have an account" />
                        </Link>
                    </View>
                </View>
            </Page>
        </>
    );
}

const styles = StyleSheet.create({
    container: {
        flexGrow: 1,
        justifyContent: "space-between",
        paddingTop: 144,
        paddingBottom: 80,
    },
    logo: {
        width: 160,
        height: 130,
    },
});
